function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M19.6,10.2272727 C19.6,9.51818182 19.5363636,8.83636364 19.4181818,8.18181818 L10,8.18181818 L10,12.05 L15.3818182,12.05 C15.15,13.3 14.4454545,14.3590909 13.3863636,15.0681818 L13.3863636,17.5772727 L16.6181818,17.5772727 C18.5090909,15.8363636 19.6,13.2727273 19.6,10.2272727 L19.6,10.2272727 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M10,20 C12.7,20 14.9636364,19.1045455 16.6181818,17.5772727 L13.3863636,15.0681818 C12.4909091,15.6681818 11.3454545,16.0227273 10,16.0227273 C7.39545455,16.0227273 5.19090909,14.2636364 4.40454545,11.9 L1.06363636,11.9 L1.06363636,14.4909091 C2.70909091,17.7590909 6.09090909,20 10,20 L10,20 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "M4.40454545,11.9 C4.20454545,11.3 4.09090909,10.6590909 4.09090909,10 C4.09090909,9.34090909 4.20454545,8.7 4.40454545,8.1 L4.40454545,5.50909091 L1.06363636,5.50909091 C0.386363636,6.85909091 1.5720758e-13,8.38636364 1.5720758e-13,10 C1.5720758e-13,11.6136364 0.386363636,13.1409091 1.06363636,14.4909091 L4.40454545,11.9 L4.40454545,11.9 Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M10,3.97727273 C11.4681818,3.97727273 12.7863636,4.48181818 13.8227273,5.47272727 L16.6909091,2.60454545 C14.9590909,0.990909091 12.6954545,1.81188398e-13 10,1.81188398e-13 C6.09090909,1.81188398e-13 2.70909091,2.24090909 1.06363636,5.50909091 L4.40454545,8.1 C5.19090909,5.73636364 7.39545455,3.97727273 10,3.97727273 L10,3.97727273 Z"
})));

function SvgIcGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgIcGoogle);
export default __webpack_public_path__ + "static/media/ic-google.40a0305b.svg";
export { ForwardRef as ReactComponent };